import React from "react";
import { PropTypes } from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
// Limitless imports
import { withi18n } from "../../../../../customer/components";
import RadioGroup from "@limitless/modern/inputs/common-radio-group/RadioGroup";
const FeedbackByVoting = ({
  classes,
  onValueChange,
  value,
  action,
  isMandatory
}) => {
  const handleVoteClick = (payloadKey, payloadValue) => {
    const expertValueToSend = {
      value: payloadValue === value.value ? "" : payloadValue
    };
    expertValueToSend.isStepComplete = expertValueToSend.value === "";
    expertValueToSend.doLiveUpdate = expertValueToSend.value !== "";
    onValueChange({
      [payloadKey]: expertValueToSend
    });
  };
  const FEEDBACK_OPTIONS = [{
    value: "yes",
    label: "Yes"
  }, {
    value: "no",
    label: "No"
  }];
  return /*#__PURE__*/React.createElement("div", {
    className: classes.feedbackByVotingContainer
  }, /*#__PURE__*/React.createElement(RadioGroup, {
    isMandatory: isMandatory,
    id: "feedback-by-voting",
    label: action.title,
    options: FEEDBACK_OPTIONS,
    onClick: vote => {
      handleVoteClick(action.payloadKey, action.data[vote].payloadValue);
    }
  }));
};
const styles = theme => ({
  feedbackByVotingContainer: {
    display: "flex",
    flexDirection: "column"
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    padding: 10,
    height: 55
  },
  mandatory: {
    color: theme.palette.error.main,
    display: "inline"
  },
  icon: {
    marginRight: 8
  }
});
export default withStyles(styles)(withi18n(FeedbackByVoting));
FeedbackByVoting.propTypes = {
  t: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  message: PropTypes.object.isRequired,
  onValueChange: PropTypes.func.isRequired,
  action: PropTypes.object.isRequired,
  value: PropTypes.object,
  isMandatory: PropTypes.bool
};